<template>
  <div
    class="emApp"
    :class="{
      'is--mobile': mobile,
      'is--theme-01': template !== '2',
      'is--theme-02': template === '2',
    }"
  >
    <header>
      <nav class="header-nav">
        <div class="left-panel">
          <router-link :to="{ name: 'index' }">
            <img :src="$logo" />
          </router-link>
        </div>
        <div class="right-panel">
          <el-dropdown @command="handleLanguageCommand" v-if="false">
            <!-- <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item v-for="it in $event.Versions" :key="it.ID" :command="it.ID">{{ ([ '中文','English'][it.Language-1]) }}</el-dropdown-item>
              </el-dropdown-menu>
            </template> -->
          </el-dropdown>
          <template v-if="$event.Versions.length > 1 && !$event.Track">
            <template v-for="it in $event.Versions">
              <div class="link language" v-if="it.ID!==$event.ID" @click="handleLanguageCommand(it.ID)">
                <el-icon>
                  <em-icon-language />
                </el-icon>
                <span>{{ ['English', '中文'][$event.Language - 1] }}</span>
              </div>
            </template>
          </template>
        </div>
      </nav>
    </header>
    <main>
      <TextScroll
        v-if="($event.Status || '').toLocaleLowerCase() === 'pending'"
        :text="
          ['您生成的活动需等待管理员审核，审核后活动可以发布，请等待审核。', 'The event will be reviewed by the supervisor. The link can be published once it\'s been approved. Thank you.'][$language]
        "
        width="100%"
        :amount="4"
        background-color="#FFF"
        :height="50"
      />
      <section><router-view /></section>
    </main>
    <footer style="margin-top: 24px; color: #666">
      <div v-if="$language == 0" style="text-align: center; width: 100%; margin: 12px 0 12px 0">Copyright © {{ new Date().getFullYear() }} Event Master 版权所有</div>
      <div v-else style="text-align: center; width: 100%; margin: 12px 0 12px 0">Copyright © {{ new Date().getFullYear() }} Event Master All rights reserved</div>
    </footer>
  </div>
</template>
<script setup>
  import TextScroll from '@/components/TextScroll.vue'

  import { useEventListener } from '@vueuse/core'
  import { ref, inject, onMounted, provide, computed } from 'vue'
  import { useRouter } from 'vue-router'
  import { LANGUAGE } from '@/config'
  import { useAppStore } from '@/store/modules/app'
  import { getSteps } from '@/api/config'

  import { storeToRefs } from 'pinia'

  import logo from '@/assets/img/logo.png'

  //const mobile = ref(false)

  const development = process.env.NODE_ENV === 'development'
  const appStore = useAppStore()
  const { loadConfig } = appStore
  const { template, mobile } = storeToRefs(appStore)

  const $event = inject('$event')
  const $language = inject('$language')
  const router = useRouter()
  const steps = ref([])
  const resizeBody = () => {
    let width = document.body.getBoundingClientRect().width
    const { setPlatform } = useAppStore()
    setPlatform(width < 1000 ? 'mobile' : 'desktop')
  }

  resizeBody()
  const cleanup = useEventListener('resize', () => {
    resizeBody()
  })

  const handleLanguageCommand = (cmd) => {
    let url = location.href
    //
    url = url.replace(/(\?|&)v=[a-zA-Z0-9]+(&|$)/, '$1v=' + cmd + '$2')
    url = url.replace(/(\?|&)_=[a-zA-Z0-9]+(&|$)/, '$1_=' + new Date().getTime() + '$2')
    //alert(url)
    location.href = url // `./#/?v=${cmd}&_=` + new Date().getTime()
    console.log('handleLanguageCommand', location.href)
    location.reload()
  }

  onMounted(async () => {
    const { data } = await getSteps()
    steps.value = data
  })

  const $logo = computed(() => {
    if ($event && $event.Config && $event.Config.ShowLogo && $event.Logo) {
      return $event.Logo
    }
    console.log('$event', $event)
    return logo
  })

  provide('$steps', steps)
</script>

<style lang="scss" scoped>
  .emApp {
    header {
      width: 100%;
      background: #353b55;
      color: #fff;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 2000;
      .header-nav {
        max-width: 1200px;
        margin: 0 auto;
        height: 68px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        padding-left: 12px;
        padding-right: 12px;
        .left-panel {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          img {
            height: 24px;
          }
        }
        .right-panel {
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
      }
    }
    main {
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
      padding-top: 68px;
      padding-left: 0;
      padding-right: 0;
      box-sizing: border-box;

      > section {
        padding: 20px;
        margin-top: 0;
      }
    }
    &.is--theme-01 {
      .header-nav {
        max-width: 1000px;
      }
      main {
        max-width: 1000px;
        > section {
          background-color: #fff;
        }
        :deep() {
          .el-card {
            &.box {
              border-color: var(--el-color-primary-light-7);
              border-width: 1px !important;
              box-shadow: none;
              margin-bottom: 20px;
              > .el-card__header {
                padding: 12px 18px;
                background-color: var(--el-color-primary-light-8);
                border-bottom: solid 1px var(--el-color-primary-light-7);
                display: flex;
                justify-content: flex-start;
                align-items: center;
                color: var(--el-color-primary);
                font-size: 14px;
                font-weight: bold;
              }
            }
          }
        }
      }
    }
    &.is--theme-02 {
      .header-nav {
        max-width: 1000px;
      }
      main {
        max-width: 1000px;
        > section {
          padding: 0px 0 0 0;
        }
      }
    }
  }
  @media screen and (max-width: 760px) {
    .emApp {
      header {
        .header-nav {
          justify-content: space-between;
          position: relative;
          padding: 0 12px;
          .left-panel {
            img {
              height: 22px;
            }
          }
        }
      }
      &.is--theme-01 {
        main {
          max-width: calc(100% - 18px);
          > section {
            padding: 0px 0 0 0;
          }
        }
      }
      &.is--theme-02 {
        main {
          max-width: calc(100% - 18px);
          > section {
            padding: 0px 0 0 0;
          }
        }
      }
    }
  }

  .link {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    > .el-icon {
      font-size: 24px;
      margin-right: 8px;
    }
    > span {
      color: #fff;
      font-size: 14px;
    }
    &.language {
      > .el-icon {
        font-size: 24px;
        margin-right: 4px;
      }
    }
  }
  .el-divider {
    margin: 0 20px;
  }
</style>
